import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "stats" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { colspan: "2" }
const _hoisted_12 = {
  class: "times",
  border: "1",
  frame: "void",
  rules: "rows",
  width: "90%"
}
const _hoisted_13 = { class: "minmax" }
const _hoisted_14 = { class: "minmax" }
const _hoisted_15 = { class: "minmax" }
const _hoisted_16 = { class: "first" }
const _hoisted_17 = { class: "minmax" }
const _hoisted_18 = { class: "minmax" }
const _hoisted_19 = { class: "minmax" }
const _hoisted_20 = { class: "first" }
const _hoisted_21 = { class: "minmax" }
const _hoisted_22 = { class: "minmax" }
const _hoisted_23 = { class: "minmax" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.$t('stats.title')), 1),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.nbEscapeNodes')), 1),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.stats['nb_escape_nodes']), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.nbIsochronePoints')), 1),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.stats['nb_njois']), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.nbCandidateNodes')), 1),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.stats['nb_candidate_nodes']), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.maxScore')), 1),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.stats['max_possible_score']), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.score')), 1),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.stats['score']), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.tightness')), 1),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("td", _hoisted_8, _toDisplayString((_ctx.stats['score']*100/_ctx.stats['max_possible_score']).toFixed(0)) + "%", 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.nbVehicles')), 1),
          _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.stats['nb_vehicles']), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t('stats.nbAssignments')), 1),
          _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.stats['nb_assignments']), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('stats.vehicleTimes')), 1)
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_12, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _cache[6] || (_cache[6] = _createElementVNode("td", { class: "first" }, null, -1)),
          _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('stats.min')), 1),
          _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('stats.avg')), 1),
          _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$t('stats.max')), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('stats.travel')), 1),
          _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.stats['time_to_dest_stats'][0]), 1),
          _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.stats['time_to_dest_stats'][1]), 1),
          _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.stats['time_to_dest_stats'][2]), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t('stats.wait')), 1),
          _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.stats['time_margin_stats'][0]), 1),
          _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.stats['time_margin_stats'][1]), 1),
          _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.stats['time_margin_stats'][2]), 1)
        ])
      ])
    ])
  ]))
}